import React from 'react'
import { Link } from 'gatsby'
import logo from '../img/logo.png'
import styled from 'styled-components';
import { COLORS } from './consts';

const Navbar = class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <Nav
       role="navigation"
       aria-label="main-navigation"
       >        
        <NavLink to="/" title="Home">
          <img src={logo} alt="" style={{ width: '256px', height: '60px' }} />
        </NavLink>            
        <NavLink to="/about">
          About
        </NavLink>
        <NavLink to="/blog">
          Blog
        </NavLink>
      </Nav>
    )
  }
}

const NavLink = styled(Link)`
  padding: 16px 16px;
  text-decoration: none;
  color: ${COLORS.Text};
  border-radius: 25px;
  &:hover {
    background-color: ${COLORS.HoverBG};
    color: ${COLORS.HoverFG};    
  }
`;

const Nav = styled.nav`
  box-shadow:none !important
  background-color: ${COLORS.Nav};
  display: flex;  
  margin: 0;
  padding: 0;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
  a:first-child:hover {
    background: ${COLORS.Nav};
  }
`;

export default Navbar
